import { render, staticRenderFns } from "./WidgetExpanedViewModal.vue?vue&type=template&id=54991942&scoped=true"
import script from "./WidgetExpanedViewModal.vue?vue&type=script&lang=js"
export * from "./WidgetExpanedViewModal.vue?vue&type=script&lang=js"
import style0 from "./WidgetExpanedViewModal.vue?vue&type=style&index=0&id=54991942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54991942",
  null
  
)

export default component.exports